module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-zhangjiakou.7a908ada.png";